import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginService} from '../../../services/login.service';
import {UserService} from '../../../services/user.service';
import {ConfigService} from '../../../services/config.service';
import { ExportToCsv } from 'export-to-csv';
import {NgxSpinnerService} from 'ngx-spinner';
import {ExportationService} from '../../../services/exportation.service';
import {CertificationService} from "../../../services/certification.service";
import {VerificationService} from '../../../services/verification.service';
import {SubCertificationService} from "../../../services/sub-certification.service";
import {SessionLogsService} from '../../../services/session-logs.service';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl} from "@angular/forms";
import {Certificat} from "../../../models/certificat.model";
import {Verification} from "../../../models/verification.model";
import {SubCertificat} from "../../../models/sub-certificat.model";

@Component({
    selector: 'app-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.css'],
    standalone: false
})
export class ExportComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  public profile_id = parseInt(localStorage.getItem('profile_id'));
  // tslint:disable-next-line:variable-name
  public user_conntected = JSON.parse(localStorage.getItem('currentUser'));

  // tslint:disable-next-line:variable-name
  public photo_url;
  // tslint:disable-next-line:variable-name
  public single_user = {
    name: null,
    photo: null,
    email: null,
    password: null,
    firstname: null,
    id: null,
  };
  previewUrl: any = null;
  successMessage: boolean;
  text: any;
  exportate = {
    type: null,
    completude: null,
  };
  public choose;
  public certificate_choose;
  public sub_certificate_choose;
  public verification_choose;
  public dataToExport = [];
  public label: any;
  public certificate_label: any;
  public sub_certificate_label: any;
  public verification_label: any;
  public urlDownload: any;

  // @ts-ignore
  public sessions: any;
  public u_remote_id: any;
  // tslint:disable-next-line:variable-name
  public site_id: any;
  // tslint:disable-next-line:variable-name
  public link: any;
  // tslint:disable-next-line:variable-name
  public link_status: any;
  // tslint:disable-next-line:variable-name
  public this_link: any;
  public session_id: any;
  public messeNotUser: boolean;
  public showDownloadButton: boolean;
  // tslint:disable-next-line:variable-name
  public date_export: any;
  public certificats: any;
  public verifications: any;
  public lenght_certificats: any;
  public value_certificat: any;
  public VerificationFormArray: any;
  public myFormVerifications: any;
  public masterSelected: any;
  private user_id: any;
  public entityType = this.config.entityType;

  constructor(public translate: TranslateService,
              public pageTitle: Title,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private loginService: LoginService,
              private userService: UserService,
              private formBuilder: UntypedFormBuilder,
              private spinner: NgxSpinnerService,
              private exportationService: ExportationService,
              private certificationService: CertificationService,
              private verificationService: VerificationService,
              private subCertificationService: SubCertificationService,
              private sessionLogsService: SessionLogsService,
              private config: ConfigService) {
    this.urlDownload = config.urlDownload;
    this.photo_url = this.config.urlDEV_images;
    if (this.user_conntected !== null) {
      if(this.user_conntected.id)
      {
        this.get_single_user_connected_details(this.user_conntected.id);
      }
      else{
        this.get_single_user_connected_details(this.user_conntected.user_id);
      }
    }
  }

  ngOnInit() {

    this.get_list_sessions_infos();
    this.config.checkUSerAccessByProfile(this.profile_id);
    if (!localStorage.getItem('currentUser')) {
      this.router.navigate(['/']);
    }
    this.u_remote_id = this.user_conntected.u_remote_id;
    this.profile_id = this.user_conntected.profile_id;

    if(this.user_conntected.id)
    {
      this.user_id = this.user_conntected.id;
    }
    else{
      this.user_id = this.user_conntected.user_id;
    }

    //list
    this.get_list_certification_by_site_user(this.user_id);
    this.get_list_verification_by_site_user(this.user_id);
    this.get_list_sub_certification_by_site_user(this.user_id);

    //Form CheckBox
    this.myFormVerifications = this.formBuilder.group({
      verification_id: this.formBuilder.array([])
    });
    this.VerificationFormArray = <UntypedFormArray>this.myFormVerifications.controls.verification_id;

  }

  AllCertificats: Certificat[] = [];
  AllVerifications: Verification[] = [];
  AllSubCertificats: SubCertificat[] = [];

  // Options triées "Libellé - code CK" pour le dropdown de recherche multisélection (IP)
  public certificatOptions: { id: number; label: string }[] = [];
  public selectedCertificatIds: number[] = [];
  public subCertificatOptions: { id: number; label: string }[] = [];
  public selectedSubCertificatIds: number[] = [];

  // tslint:disable-next-line:variable-name
  get_single_user_connected_details(id_user: number) {
    this.userService.getUser(id_user)
      .subscribe(res => {
        this.single_user.firstname = res.data.firstname;
        this.single_user.name = res.data.name;
        this.single_user.email = res.data.email;
        this.single_user.password = res.data.password;
        this.single_user.id = res.data.id;
        this.single_user.photo = this.photo_url + '' + res.data.photo;
      }, (err) => {
        console.log(err);
      });
  }

  // tslint:disable-next-line:variable-name
  get_list_sessions_infos() {
    this.userService.get_sessions_list()
      .subscribe(res => {
        this.sessions = res.data;
      }, (err) => {
        console.log(err);
      });
  }

  chooseType(e) {
    this.choose = e.target.value;
    this.label = e.target.options[e.target.options.selectedIndex].text;
  }

  chooseCertificats(e) {
    this.certificate_choose = e.target.value;
    this.certificate_label = e.target.options[e.target.options.selectedIndex].text;


  }

  chooseVerifications(e) {
    this.verification_choose = e.target.value;
    this.verification_label = e.target.options[e.target.options.selectedIndex].text;
  }

  chooseSubCertificats(e) {
    this.sub_certificate_choose = e.target.value;
    this.sub_certificate_label = e.target.options[e.target.options.selectedIndex].text;
  }

  formatDate() {
    // tslint:disable-next-line:one-variable-per-declaration
    const d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    const hour = d.getHours();
    const minute = d.getMinutes();
    const seconde = d.getSeconds();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    const dateJoin = [year, month, day].join('');
    const hourJOin = [hour, minute, seconde].join('');
    return [dateJoin, hourJOin].join('_');
  }

  choose_config(choose) {
    if (choose === '0') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.items', {label: this.label}),
        filename: this.label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: [this.translate.instant('exportHeaders.id'), this.translate.instant('exportHeaders.label')]
      };
      return options;
    }
    if (choose === '1') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.items', {label: this.label}),
        filename: this.label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: [this.translate.instant('exportHeaders.id'), this.translate.instant('exportHeaders.courseTitle'), this.translate.instant('exportHeaders.description'), this.translate.instant('exportHeaders.keywords'), this.translate.instant('exportHeaders.importDate'), this.translate.instant('exportHeaders.estimatedDuration'), this.translate.instant('exportHeaders.createdAt'), this.translate.instant('exportHeaders.reference'), this.translate.instant('exportHeaders.notStarted'), this.translate.instant('exportHeaders.inProgress'), this.translate.instant('exportHeaders.invalid'), this.translate.instant('exportHeaders.valid'), this.translate.instant('exportHeaders.total'), this.translate.instant('exportHeaders.score'), this.translate.instant('exportHeaders.averageTime'), this.translate.instant('exportHeaders.site'), this.translate.instant('exportHeaders.siteId'), this.translate.instant('exportHeaders.session'), this.translate.instant('exportHeaders.sessionId')]
      };
      return options;
    }
    if (choose === '2') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.items', {label: this.label}),
        filename: this.label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: [this.translate.instant('exportHeaders.id'), this.translate.instant('exportHeaders.label'), this.translate.instant('exportHeaders.startDate'), this.translate.instant('exportHeaders.endDate'), this.translate.instant('exportHeaders.state'), this.translate.instant('exportHeaders.notStarted'), this.translate.instant('exportHeaders.inProgress'), this.translate.instant('exportHeaders.invalid'), this.translate.instant('exportHeaders.valid'), this.translate.instant('exportHeaders.total'), this.translate.instant('exportHeaders.score'), this.translate.instant('exportHeaders.averageTime'), this.translate.instant('exportHeaders.siteId'), this.translate.instant('exportHeaders.siteName')]
      };
      return options;
    }
    if (choose === '3') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.items', {label: this.label}),
        filename: this.label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: [this.translate.instant('exportHeaders.id'), this.translate.instant('exportHeaders.learningUnitTitle'), this.translate.instant('exportHeaders.description'), this.translate.instant('exportHeaders.estimatedDuration'), this.translate.instant('exportHeaders.sites'), this.translate.instant('exportHeaders.course'), this.translate.instant('exportHeaders.courseId')]
      };
      return options;
    }
    if (choose === '4') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.items', {label: this.label}),
        filename: this.label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: [this.translate.instant('exportHeaders.learnerName'), this.translate.instant('exportHeaders.connected')]
      };
      return options;
    }
    // certificat choose
    if (choose === '5') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.certificate', {label: this.certificate_label}),
        filename: this.certificate_label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        // headers: ['Entreprise', 'GroupeModel', 'nom', 'prénom', 'email ', 'identifiant', 'Code CertiKap', 'nom Certificat', 'Titre du parcours','ID du parcours', 'date de certification', 'date de fin de validité', 'statut du certificat']
        headers: ['']
      };
      return options;
    }
    //certificats all
    if (choose === '6') {
      if (this.certificate_choose) {
        const options = {
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: this.translate.instant('alerts.exportCertificates'),
          filename: this.label + '_' + this.formatDate(),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: false,
          // tslint:disable-next-line:max-line-length
          headers: ['']
        };
        return options;

      }
    }

    //verificat choose
    if (choose === '7') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.verification', {label: this.verification_label}),
        filename: this.verification_label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: ['']
      };
      return options;
    }

    //sub_certification choose
    if (choose === '8') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.subCertification', {label: this.sub_certificate_label}),
        filename: this.sub_certificate_label + '_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: ['']
      };
      return options;
    }
    
    //logs_sessions choose
    if (choose === '9') {
      const options = {
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: this.translate.instant('export.titles.sessionLogs'),
        filename: 'logs_sessions_' + this.formatDate(),
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: false,
        // tslint:disable-next-line:max-line-length
        headers: ['']
      };
      return options;
    }
  }


  exportation() {
    // Si c'est l'export des logs de session, utiliser la méthode spécialisée
    if (this.choose === '9') {
      this.exportSessionLogs();
      return;
    }

    this.spinner.show();
    this.link_status = false;
    this.link = 'En cours de téléchargement';
    const body = {
      export_type: this.choose,
      completude: this.exportate.completude,
      session_id: this.session_id,
      user_id: this.u_remote_id,
      profile_id: this.user_conntected.profile_id,
      id: this.user_id,
      array_certification: this.selectedCertificatIds,
      array_verification: this.VerificationFormArray.value,
      array_sub_certification: this.selectedSubCertificatIds,
    };
    this.userService.exportation(body)
      .subscribe(res => {
        // Sites Export
        if (res.export_type === '0') {
          const options = this.choose_config(this.choose);
          res.data.forEach((rdata, index) => {
            const data = {
              ID: rdata.site_id,
              Intitulé: rdata.site_name,
            };
            this.dataToExport.push(data);
          });
          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(this.dataToExport);
        }

        // Parcours Export
        if (res.export_type == '1') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export + '.csv';
            window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        // Session Export
        if (res.export_type == '2') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export + '.csv';
            window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        // Ua Export
        if (res.export_type === '3') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export + '.csv';
            window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        // Export des personnes connectés
        if (res.export_type == '4') {
          this.dataToExport = [];
          const options = this.choose_config(this.choose);
          if (res.data.length === 0) {
            this.messeNotUser = true;
            this.spinner.hide();
            return false;
          }
          res.data.forEach((rdata, index) => {
            const data = {
              nom_apprenant: rdata.user.fullname,
              est_connecte: rdata.user.is_connected.length === 0 ? 'Non' : 'Oui',
            };

            this.dataToExport.push(data);
          });
          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(this.dataToExport);
        }
        if (res.export_type == '5') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export;
            window.location.href = this.urlDownload + '' + this.date_export;
            this.link = window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        if (res.export_type == '6') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export;
            window.location.href = this.urlDownload + this.date_export;
          }
        }
        if (res.export_type == '7') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export;
            window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        if (res.export_type == '8') {
          if (res.success === true) {
            this.showDownloadButton = true;
            this.date_export = res.data.date_export;
            window.location.href = this.urlDownload + '' + this.date_export;
          }
        }
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }

  exportSessionLogs() {
    this.spinner.show();
    this.link_status = false;
    this.link = 'En cours de téléchargement';

    this.sessionLogsService.getSessionLogsByUser(this.user_id).subscribe({
      next: (res) => {
        console.log('Response complète:', res);
        // Essayer différentes structures de réponse
        let logsData = null;
        if (res && res.logs) {
          logsData = res.logs;
        } else if (res && res.data) {
          logsData = res.data;
        } else if (Array.isArray(res)) {
          logsData = res;
        }
        
        console.log('Logs data:', logsData);
        
        if (logsData && logsData.length > 0) {
          let filteredData = logsData;
          
          const isSiteAdmin = this.profile_id === 12; 
          
          if (isSiteAdmin) {
            const userSiteId = this.user_conntected.site_id || this.site_id;
            if (userSiteId) {
              filteredData = logsData.filter((log: any) => log.site_id === userSiteId);
            }
          }
          
          console.log('Filtered data:', filteredData);
          this.createSessionLogsCSV(filteredData);
        } else {
          console.error('Aucune donnée de logs de session trouvée', res);
        }
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Erreur lors de la récupération des logs de session:', error);
        this.spinner.hide();
      }
    });
  }

  // Créer et télécharger le fichier CSV des logs de session
  createSessionLogsCSV(data: any[]) {
    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: this.translate.instant('export.titles.sessionLogs'),
      filename: 'logs_sessions_' + this.formatDate(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true  // Utilise automatiquement les clés comme headers
    };

    console.log('Data reçue pour CSV:', data);
    
    if (data.length === 0) {
      console.warn('Aucune donnée à exporter');
      return;
    }

    // Exporter directement les données sans mapping complexe
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
  }



  chooseCompletude(e) {
    this.exportate.completude = e.target.value;
  }

  get_list_certification_export() {
    this.certificationService.getCertificat()
      .subscribe(res => {
        // @ts-ignore
        this.certificats = res.data.certificat;
      }, (err) => {
        console.log(err);
      });
  }

  get_list_certification_by_site_user(user_id) {
    this.certificationService.getCertificatBySiteUser(user_id)
      .subscribe(res => {
        // @ts-ignore
        this.AllCertificats = res.data;
        this.buildCertificatOptions();
      }, (err) => {
        console.log(err);
      });
  }

  buildCertificatOptions() {
    this.certificatOptions = this.AllCertificats
      .map(c => ({id: c.id, label: c.code_cert ? `${c.name} - ${c.code_cert}` : c.name}))
      .sort((a, b) => a.label.localeCompare(b.label, 'fr', {sensitivity: 'base'}));
  }

  selectAllCertificats(selectAll: boolean) {
    this.selectedCertificatIds = selectAll ? this.AllCertificats.map(c => c.id) : [];
  }

  get_list_verification_by_site_user(user_id) {
    this.verificationService.getVerificationBySiteUser(user_id)
      .subscribe(res => {
        // @ts-ignore
        this.AllVerifications = res.data;
      }, (err) => {
        console.log(err);
      });
  }

  get_list_sub_certification_by_site_user(user_id) {
    this.subCertificationService.getSubCertificatBySiteUser(user_id)
      .subscribe(res => {
        // @ts-ignore
        this.AllSubCertificats = res.data;
        this.buildSubCertificatOptions();
      }, (err) => {
        console.log(err);
      });
  }

  buildSubCertificatOptions() {
    this.subCertificatOptions = this.AllSubCertificats
      .map(c => ({id: c.id, label: c.code_cert ? `${c.name} - ${c.code_cert}` : c.name}))
      .sort((a, b) => a.label.localeCompare(b.label, 'fr', {sensitivity: 'base'}));
  }

  selectAllSubCertificats(selectAll: boolean) {
    this.selectedSubCertificatIds = selectAll ? this.AllSubCertificats.map(c => c.id) : [];
  }


  get_list_verification_export() {
    this.verificationService.getVerification()
      .subscribe(res => {
        // @ts-ignore
        this.verifications = res.data.verifications;
      }, (err) => {
        console.log(err);
      });
  }

  choose_certificate(certificate_choose) {
    const options = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: this.translate.instant('export.titles.items', {label: this.label}),
      filename: this.label + '_' + this.formatDate(),
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: false,
      // tslint:disable-next-line:max-line-length
      headers: [this.translate.instant('exportHeaders.id'), this.translate.instant('exportHeaders.label')]
    };
    return options;
  }

//Check Verification
  check_verifications(verification_id: number, event: boolean) {
    if (event) {
      this.VerificationFormArray.push(new UntypedFormControl(verification_id));
    } else {
      let index = this.VerificationFormArray.controls.findIndex(x => x.value == verification_id)
      this.VerificationFormArray.removeAt(index);
    }
  }

}
